import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import getPage from "~/helpers/getPage"
import Documents from "~/views/documents"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [
      {
        url: "/documents/elements",
        code: "quarterreports",
      },
    ],
    req ? req.headers.host : location.host,
  )

  const { name } = apiContext["/documents/elements"].response
  const crumbs = generateCrumbs(req?.url, name)

  return { apiContext, crumbs }
}

const Page = getPage(getInitialProps, Documents)

export default Page
